import { useUserContext } from "../Contexts/userContext";
import { Role } from "../services/Enums";

export const useRoleAccess = () => {
  const { user } = useUserContext();

  const isAdmin = () => user?.role === Role.Admin;
  const isEditor = () => user?.role === Role.Editor;
  const isTeacher = () => user?.role === Role.Teacher;
  const isViewer = () => user?.role === Role.Viewer;

  const hasRole = (role: Role) => user?.role === role;
  const hasRoleOrHigher = (role: Role) => (user?.role ?? 0) >= role;

  return {
    isAdmin,
    isEditor,
    isTeacher,
    isViewer,
    hasRole,
    hasRoleOrHigher,
  };
};
